module.exports = __webpack_public_path__ + "doctor_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_6.jpg
// module id = 893
// module chunks = 0